export class UserOrgUnit {
    userId: number;
    orgUnitId: number;
}